import { render, staticRenderFns } from "./CouponsManager.vue?vue&type=template&id=cf1e8b04&"
import script from "./CouponsManager.vue?vue&type=script&lang=js&"
export * from "./CouponsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports